















import {Component, Model, Prop, Vue} from "vue-property-decorator";
import api from "@/api";
import {
  AttachmentCreateOrUpdateDto,
  AttachmentDto,
  AttachmentHostType,
} from "@/api/appService";
import OSS from "ali-oss";
import Guid from "guid";

interface UploadTask {
  client: any;
  canceled: boolean;
}

@Component({
  name: "multipleUploadFile",
})
export default class multipleUploadFile extends Vue {
  @Model("change", {type: Array, default: () => []}) readonly fileIds?:
    | number[]
    | undefined;

  @Prop({required: false})
  hostType!: AttachmentHostType;

  @Prop({required: true})
  hostId!: string | number;

  attachmentList?: AttachmentDto[] = [];
  attachmentIds?: number[] = [];
  private uploadTasks: {[uid: string]: UploadTask} = {};

  created() {
    let hostId = "";
    if (typeof this.hostId === "number") {
      hostId = this.hostId.toString();
    } else {
      hostId = this.hostId;
    }
    api.attachmentService
      .getAttachments({
        hostId: hostId,
        hostType: this.hostType,
      })
      .then((res) => {
        this.attachmentList = res;
        if (this.attachmentList!.length > 0) {
          this.attachmentList!.map((item: any) => {
            item.name = item.fileName;
            this.attachmentIds!.push(item.id);
          });
        }
        this.$emit("change", this.attachmentIds);
      });
  }

  fnUploadRequest(options: any) {
    const file = options.file;
    const dotIndex = file.name.lastIndexOf(".");
    const ext = dotIndex >= 0 ? file.name.substring(dotIndex + 1) : "";
    const objectName = ext
      ? "oss/file/" + Guid.raw() + "." + ext
      : "oss/file/" + Guid.raw();

    api.attachmentService
      .getAliyunOssStsToken()
      .then((sts) => {
        const client = new OSS({
          region: sts.region,
          accessKeyId: sts.credentials?.accessKeyId ?? "",
          accessKeySecret: sts.credentials?.accessKeySecret ?? "",
          stsToken: sts.credentials?.securityToken,
          endpoint: sts.endpoint,
          bucket: sts.bucket,
          secure: true,
          cname: false,
          timeout: 180000,
        });
        const task: UploadTask = {client, canceled: false};
        this.uploadTasks[file.uid] = task;

        const run = async () => {
          let result: any;
          try {
            result = await client.multipartUpload(objectName, file, {
              parallel: 4,
              partSize: 5 * 1024 * 1024,
              progress: (p: number) => {
                if (task.canceled) {
                  return;
                }
                options.onProgress({
                  percent: Math.round(p * 100),
                  returnValue: true,
                });
              },
            });
          } catch (e) {
            if (!task.canceled) {
              console.log(e);
              options.onError(e);
              this.$message.error("上传失败，请重试");
            }
            delete this.uploadTasks[file.uid];
            return;
          }
          if (task.canceled) {
            delete this.uploadTasks[file.uid];
            return;
          }
          try {
            await this.registerAttachment(
              result,
              file,
              sts.fileUrl ?? "",
              sts.imageUrl ?? "",
              options,
              task
            );
          } catch (e) {
            if (!task.canceled) {
              console.log(e);
              options.onError(e);
            }
          } finally {
            delete this.uploadTasks[file.uid];
          }
        };
        run();
      })
      .catch((e) => {
        console.log(e);
        options.onError(e);
      });
  }

  private async registerAttachment(
    res: any,
    file: any,
    fileUrl: string,
    imageUrl: string,
    options: any,
    task: UploadTask
  ) {
    const regex = /(\.(jpg|jpeg|png|bmp|gif))$/i;
    const isImage = regex.test(res.name);
    let url = isImage ? imageUrl : fileUrl;
    if (url && url.lastIndexOf("/") !== url.length - 1) {
      url += "/";
    }

    const attachment: AttachmentCreateOrUpdateDto = {
      id: 0,
      url: url + res.name,
      fileName: file.name,
      fileSize: file.size != null ? String(file.size) : undefined,
      contentLength: file.size,
      contentType: file.type,
      hostId: this.resolveHostId(),
      hostType: this.hostType,
    };

    const uploadResult: any = await api.attachmentService.uploadAttachment({
      body: attachment,
    });
    if (task.canceled) {
      return;
    }
    if (!uploadResult || uploadResult.attachmentId == null) {
      const message =
        typeof uploadResult === "string" ? uploadResult : "附件保存失败，请重试";
      if (typeof uploadResult !== "string") {
        this.$message.error(message);
      }
      options.onError(new Error(message));
      return;
    }

    options.onSuccess({
      success: true,
      result: {
        attachmentId: uploadResult.attachmentId,
        url: attachment.url,
        fileName: file.name,
      },
    });
  }

  private resolveHostId() {
    if (
      this.hostId === undefined ||
      this.hostId === null ||
      this.hostId === "" ||
      this.hostId === 0 ||
      this.hostId === "0"
    ) {
      return undefined;
    }
    return String(this.hostId);
  }

  // 上传成功
  async onSuccess(res: any, file: any) {
    if (res && res.success && res.result) {
      file.url = res.result.url;
      file.id = res.result.attachmentId;
      this.attachmentIds!.push(res.result.attachmentId);
      this.$emit("change", this.attachmentIds);
    }
  }

  // 删除前
  beforeRemove(file: any) {
    return this.$confirm(`确定移除 ${file.name}？`);
  }

  // 删除成功
  onRemove(file: any) {
    const task = this.uploadTasks[file.uid];
    if (task) {
      task.canceled = true;
      try {
        task.client.cancel();
      } catch (e) {
        console.log(e);
      }
    }

    this.$emit("onRemove", file);
    let id = file.id;
    if ((id === undefined || id === null) && file.response && file.response.result) {
      id = file.response.result.attachmentId;
    }
    const index = this.attachmentIds!.indexOf(id);
    if (index > -1) {
      this.attachmentIds!.splice(index, 1);
      this.$emit("change", this.attachmentIds);
    }
  }

  onPreview(file: any) {
    if (file.url) {
      window.open(file.url);
    }
  }
}
